import React from 'react';
import { useLocation } from 'react-router-dom';
import { FormikErrors, FormikTouched, FormikProps } from 'formik';
import * as Yup from 'yup';
import Wizard, { Props } from '@service-victoria/component-library/components/Wizard';
import { storage as storageUtils } from '@service-victoria/component-library/utils/storage';
import * as Interfaces from 'interfaces';
import { app as appContext } from 'context';
import useAvailable from 'hooks/useAvailable';
import * as Steps from 'steps';
import { constants, storage } from 'utils';

const Transaction: React.FC = () => {
  // Check with backend if transaction can be processed
  useAvailable();

  // The wizard was created with "hash" url support, so we need to extract its value to know at what step the user was
  const location = useLocation();
  const context = appContext.useAppContext();
  const { hash } = location;

  // Get the current hash value of the url to set initialStep index (to load the user in same step in case the screen got refershed in middle of the process)
  // const initialStepId = hash.substr(1) ? hash.substr(1) : Steps.Step1.Step.id;
  const initialStepId = hash.substr(1) ? hash.substr(1) : Steps.Select.Step.id;

  const steps: Props.Step<any>[] = [
    Steps.Select.Step,
    Steps.Identity.Step,
    Steps.VisitVictoria.Step,
    Steps.Review.Step,
    Steps.Done.Step
  ];

  /**
   * Try to load existing form state from the browser storage in case of user refresh
   */
  const initialState = storage.getStorage<Interfaces.Common.FormValues>(
    constants.StorageKeys.Wizard
  );

  const initialValues: Interfaces.Common.FormValues = {
    prerequisiteChecks:
      initialState.prerequisiteChecks ?? Steps.Select.initialValues.prerequisiteChecks,
    identity: initialState.identity ?? Steps.Identity.initialValues.identity
  };
  const initialErrors: FormikErrors<Interfaces.Common.FormValues> = {
    ...Steps.Select.initialErrors,
    ...Steps.Identity.initialErrors,
    ...Steps.VisitVictoria.initialErrors,
    ...Steps.Review.initialErrors
  } as FormikErrors<Interfaces.Common.FormValues>;
  const initialTouched: FormikTouched<Interfaces.Common.FormValues> = {
    ...Steps.Select.initialTouched,
    ...Steps.Identity.initialTouched,
    ...Steps.VisitVictoria.initialTouched,
    ...Steps.Review.initialTouched
  } as FormikTouched<Interfaces.Common.FormValues>;

  const validationSchema = Yup.object().shape<Interfaces.Common.FormValues>({
    prerequisiteChecks: Steps.Select.wizardSchema,
    identity: Steps.Identity.wizardSchema
  });

  const onWindowClose = (formProps: FormikProps<Interfaces.Common.FormValues>) => {};

  const wizardStorage: Props.Storage<Interfaces.Common.FormValues> = {
    key: constants.StorageKeys.Wizard,
    loadOnMount: true,
    ...storageUtils(sessionStorage)
  };

  const initialAppStates: Props.AppContextStates = {
    [constants.StorageKeys.State]: context
  };

  return (
    <Wizard
      initialAppStates={initialAppStates}
      initialValues={initialValues}
      initialTouched={initialTouched}
      initialErrors={initialErrors}
      storage={wizardStorage}
      onWindowClose={onWindowClose}
      validationSchema={validationSchema}
      steps={steps}
      initialStepId={initialStepId}
      isStepperEnabed
      isHashEnabled
    />
  );
};

export default Transaction;
